const EMAILJS_ENDPOINT = 'https://api.emailjs.com/api/v1.0/email/send';

function normalizeEnv(value) {
  if (!value) return '';
  const trimmed = value.trim();
  return trimmed.replace(/^['"]|['"]$/g, '');
}

function getConfig() {
  const serviceId = normalizeEnv(process.env.REACT_APP_EMAILJS_SERVICE_ID);
  const templateId = normalizeEnv(process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
  const publicKey = normalizeEnv(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  const toEmail = normalizeEnv(process.env.REACT_APP_CONTACT_TO_EMAIL);

  if (!serviceId || !templateId || !publicKey) {
    throw new Error('Manjkajo EmailJS nastavitve v .env datoteki.');
  }

  return { serviceId, templateId, publicKey, toEmail };
}

async function sendEmailJsRequest({ serviceId, templateId, publicKey, templateParams }) {
  const response = await fetch(EMAILJS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: templateParams,
    }),
  });

  if (!response.ok) {
    const raw = await response.text();

    let details = raw || `HTTP ${response.status}`;
    try {
      const parsed = JSON.parse(raw);
      details = parsed?.text || parsed?.message || details;
    } catch (_parseError) {
      // Keep raw text when response is not JSON.
    }

    throw new Error(`EmailJS napaka (${response.status}): ${details}`);
  }
}

export async function sendContactEmail({ name, email, subject, message }) {
  const { serviceId, templateId, publicKey, toEmail } = getConfig();

  await sendEmailJsRequest({
    serviceId,
    templateId,
    publicKey,
    templateParams: {
      from_name: name,
      from_email: email,
      reply_to: email,
      subject,
      message,
      to_email: toEmail || '',
    },
  });
}
